export default __webpack_public_path__ + "static/media/funding.c7d95bc7.png";